import { useHref, useStrings } from '../i18n.js';

/**
 * The one call to action on a use-case page.
 *
 * It sends people to the homepage, where the real form lives. Duplicating the create
 * form onto every content page would mean four places for the creation flow to drift
 * apart, and would put a live form next to ad inventory.
 */

interface UseCaseCtaProps {
  title: string;
  body: string;
}

export function UseCaseCta({ title, body }: UseCaseCtaProps) {
  const s = useStrings();
  const href = useHref();

  return (
    <section className="section section--tint">
      <div className="section__inner section__inner--narrow">
        <div className="card stack">
          <h2 className="card__title">{title}</h2>
          <p className="card__subtitle">{body}</p>
          <div>
            <a className="button button--primary" href={href('/')}>
              {s.createForm.submit}
            </a>
            <p className="trust-line">{s.createForm.trustLine}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
